import { mdiDelete } from "@mdi/js";
import Icon from "@mdi/react";
import {
  AttachmentModel,
  FileType,
  getFileType,
} from "../../../purchase_order/model/purchase_order_model";
import FileDropZone from "../../../../ui/new_components/common/file_drop_zone";
import { FunctionComponent, useEffect, useState } from "react";

interface MultiAttachmentSectionProps {
  attachments: AttachmentModel[];
  category: string;
  onSubmit: (data: {
    file: File;
    category: string;
  }) => Promise<AttachmentModel>;
  onDelete: (data: AttachmentModel) => void;
  disabled?: boolean;
  id?: string;
}

const MultiAttachmentSection: FunctionComponent<
  MultiAttachmentSectionProps
> = ({ attachments, onSubmit, onDelete, category, disabled = false, id }) => {
  const [files, setFiles] = useState<AttachmentModel[]>(attachments);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    setFiles(attachments);
  }, [attachments]);

  const handleFileDrop = async (droppedFiles: File[]) => {
    setUploading(true);
    for (const file of droppedFiles) {
      try {
        const uploadedFile = await onSubmit({
          file,
          category: category,
        });
        setFiles((prevFiles) => [...prevFiles, uploadedFile]);
      } catch (error) {
        console.error("File upload failed", error);
      }
    }
    setUploading(false);
  };

  const removeFile = (file: AttachmentModel) => {
    onDelete(file);
    setFiles((prevFiles) => prevFiles.filter((f) => f.id !== file.id));
  };

  return (
    <div className="p-2 md:p-5" id={id}>
      <div className="mb-4 relative">
        {uploading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75">
            Uploading...
          </div>
        )}

        {/* Show dropzone only if not disabled */}
        {!disabled && (
          <FileDropZone
            onDrop={handleFileDrop}
            id={id ? `${id}-dropzone` : undefined}
          />
        )}
        {/* : (
           <div className="border rounded-md p-5 text-gray-500 text-center cursor-not-allowed">
             File upload disabled
           </div>
         ) */}
      </div>

      <div className="space-y-4 max-h-96 overflow-y-auto">
        {files.map((fileObj) => (
          <div
            key={fileObj.id}
            id={id ? `${id}-item-${fileObj.id}` : undefined}
            className="flex items-center justify-between p-3 border rounded-md"
          >
            <div className="flex items-center gap-3 min-w-0">
              {getFileType(fileObj.type) === FileType.IMAGE ? (
                <img
                  src={fileObj.url}
                  alt={""}
                  className="w-16 h-16 object-cover"
                />
              ) : (
                <a
                  href={fileObj.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm break-all"
                >
                  {fileObj.url}
                </a>
              )}
            </div>

            {/* Showing delete only if not disabled */}
            {!disabled && (
              <button
                id={id ? `${id}-delete-${fileObj.id}` : undefined}
                onClick={() => removeFile(fileObj)}
                className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600"
              >
                <Icon path={mdiDelete} size={0.8} />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiAttachmentSection;
